<template>
	<v-dialog v-model="nipDialog" max-width="500">
		<v-card>
			<v-card-title class="headline">Podany NIP już istnieje w systemie</v-card-title>

			<v-card-text>
				Oferent o podanym numerze NIP już został zarejestrowany w systemie.
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn color="green darken-1"
					flat="flat"
					@click="$emit('close')">
					Ok
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
	export default {
		name: "user-with-this-nip-exists-dialog",

		props: {
			nipDialog: {},
		},
	};
</script>
